import { BrainInterface, NLPBrainAction, NLPBrainActionType } from "@swivl-mono/types";
import { SelectableOption, Switch } from "@swivl-mono/ui";

import { QuestsDropdown } from "../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";
import { BrainsModel } from "../../../Models/Brains/Brains.Model";
import "./BrainsViewIntent.scss";

interface Props {
  brain: BrainInterface;
  action: NLPBrainAction;
  isParent: boolean;
  isDefault?: boolean;
  brainItems: SelectableOption[];
}
export function BrainsViewIntent({ brain, action, isDefault, isParent, brainItems }: Props) {
  const brainOrQuestSelected = (option: SelectableOption, name: string) => {
    let newAction: any = { ...action };
    newAction.active = true;

    if (option.data?.isBrain) {
      newAction.type = NLPBrainActionType.BRAIN;
      newAction.goto = option.value.replace("brain_", "");
    } else {
      newAction.type = NLPBrainActionType.QUEST;
      newAction.goto = option.value;
    }
    if (isDefault) {
      brain.data.unhandled = newAction;
    } else {
      brain.data.actions[newAction.intent] = newAction;
    }
    BrainsModel.updateBrain(brain, true);
  };
  const actionOnChange = (on: boolean, switchName?: string) => {
    let newAction: any = { ...action };
    newAction.active = on;
    if (isDefault) {
      brain.data.default = newAction;
    } else {
      brain.data.actions[newAction.intent] = newAction;
    }
    BrainsModel.updateBrain(brain, true);
  };

  if (action.type === NLPBrainActionType.BRAIN) {
  }
  return (
    <div className="BrainsViewIntent">
      <div className="intent">{isDefault ? "Default Unhandled" : action.intent}</div>
      <div className={`type type-${action.type}`}>{action.type}</div>

      <div className="goto">
        <div className="dropDownWrapper">
          <QuestsDropdown
            prependOptions={brainItems}
            optionSelected={brainOrQuestSelected}
            value={action.type === NLPBrainActionType.BRAIN ? "brain_" + action.goto : action.goto}
            disableEditing={isParent}
          />
        </div>
      </div>
      <Switch on={action.active || isDefault ? true : false} name="active" onSet={actionOnChange} isDisabled={isParent} />
    </div>
  );
}
